module.exports = __webpack_public_path__ + "static/media/back.4c9f24b6.svg";